export default "__VITE_ASSET__D6cvT8Ov__"